import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[appSpaceRemover]',
})
export class SpaceRemoverDirective {
  @HostListener('keyup', ['$event'])
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onKeyUp(event: any) {
    const input = event.target;
    input.value = this.formatValue(input.value);
  }

  private formatValue(inputValue: string) {
    return inputValue.replace(/\s/g, '');
  }
}
